<script>
export default {
  props: {
    defaultOpen: Boolean,
    title: String,
    customClass: String,
  },
  data() {
    return {
      isOpen: this.defaultOpen || false,
    }
  },
  methods: {
    open() {
      this.isOpen = true
    },
    close() {
      this.isOpen = false
      this.$emit('close')
    },
  }
}
</script>

<template>
  <portal selector="body">
    <div v-if="isOpen" class="bottom-sheet-wrapper">
      <div class="bottom-sheet-backdrop"></div>
      <div class="bottom-sheet" :class="customClass">
        <div class="bottom-sheet__drag-indicator">
          <div />
        </div>
        <div class="bottom-sheet__header">
          <p>{{ title }}</p>
          <button class="close" @click="close">
            <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M4 4.48804L12 12.488M4 12.488L12 4.48804L4 12.488Z" stroke="#6C7E95" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
        <div class="bottom-sheet__content">
          <slot />
        </div>
        <div class="bottom-sheet__footer">
          <div />
        </div>
      </div>
    </div>
  </portal>
</template>

<style lang="scss" scoped>
.bottom-sheet {
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  background-color: #FFF;
  padding: 16px 16px 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  border-radius: 16px 16px 0 0;

  &__drag-indicator {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 16px;
    cursor: grab;

    & > div {
      width: 32px;
      height: 4px;
      border-radius: 50px;
      background-color: #BFCEE0;
    }
  }

  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    height: 24px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    & > div {
      width: 134px;
      height: 4px;
      border-radius: 50px;
      background-color: #203551;
    }
  }

  &__header {
    display: flex;
    gap: 12px;
    justify-content: space-between;
    align-items: center;

    p {
      margin: 0 !important;
      color: #203551;
      font-family: Inter;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
    }
    .close {
      border: none;
      height: 22px;
      width: 22px;
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #F6F8FC;
      border-radius: 90px;
    }
  }

  &-backdrop,
  &-wrapper {
    position: fixed;
    bottom: 0;
    left: 0;
    height: 100%;
    width: 100%;
  }

  &-wrapper {
    z-index: 9999; // z-index floating buy button
  }

  &-backdrop {
    background-color: #000;
    opacity: 0.3;
  }
}
</style>